export interface QuoteReminderTemplate {
  id: string;
  step: number;
  template_key: string;
  version: number;
  is_active: boolean;
  label: string;
  angle: string;
  subject: string;
  intro: string;
  highlight: string;
  body: string;
  high_value_threshold: number;
  high_value_highlight: string | null;
  high_value_body: string | null;
  whatsapp_enabled: boolean;
  whatsapp_body: string | null;
  updated_by: string | null;
  created_at: string;
  updated_at: string;
}

export type QuoteReminderTemplateUpdate = Pick<
  QuoteReminderTemplate,
  | "label"
  | "angle"
  | "subject"
  | "intro"
  | "highlight"
  | "body"
  | "high_value_threshold"
  | "high_value_highlight"
  | "high_value_body"
  | "whatsapp_enabled"
  | "whatsapp_body"
>;

export const QUOTE_REMINDER_VARIABLES = [
  { key: "clientFirstName", label: "Prénom client", example: "Marie" },
  { key: "brandName", label: "Marque", example: "Smile World" },
  { key: "centerName", label: "Centre", example: "Bercy" },
  { key: "eventDate", label: "Date événement", example: "15/03/2026" },
  { key: "participants", label: "Participants", example: "25" },
  { key: "amountHt", label: "Montant HT", example: "2400 € HT" },
  { key: "signatureLink", label: "Lien signature", example: "https://event.smile-world.fr/sign/..." },
];

const PREVIEW_VALUES: Record<string, string> = {
  clientFirstName: "Marie",
  brandName: "Smile World",
  centerName: "Bercy",
  eventDate: "15/03/2026",
  participants: "25",
  amountHt: "2400 € HT",
  signatureLink: "https://event.smile-world.fr/sign/exemple",
};

export function previewQuoteReminderText(template: string): string {
  return template.replace(/\{(\w+)\}/g, (_match, key) => PREVIEW_VALUES[key] ?? "");
}
